/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';
import {
  convertDate,
  formatter,
  validateData,
} from '../../../constants/CommonMethods';
import { useTranslation } from 'react-i18next';

export default function PrintPriceTagDocument(props: any) {
  console.log('props inside printPriceTagDoc',props);
  const headerData = props.header;
  const priceData = props.priceDetails;
  const invenData = props.invenDetails;
  const cityName = props.storeDetail;
  const {t} = useTranslation('InventoryTabs');
  const language: any = window.sessionStorage.getItem('language');
 
  const queued = validateData(headerData)
    ? validateData(headerData.priceTagQueued)
      ? headerData.priceTagQueued === true
        ? t('Yes')
        : t('No')
      : ''
    : {};

  return (
    <div>
      <head>
        <title></title>
      </head>
      <body>
        <div
          style={{
            // marginBottom: '400px',
            width: '100%',
            float: 'left',
            fontFamily: 'Arial',
          }}
        >
          <div style={{ width: '100%', marginBottom: '10px' }}>
            <span style={{ fontSize: '22px', fontWeight: 'bold' }}>
              {t('Price Tag')}
            </span>
            <span style={{ float: 'right', fontStyle: 'italic' }}>
              {t(convertDate(new Date(), 'ddd'))+','+convertDate(new Date(), 'DD MMM YYYY hh:mm A')}
            </span>
          </div>

          <div style={{ width: '100%', float: 'left' }}>
            <div
              style={{ float: 'left', marginRight: '1%', fontSize: '14px',width:'25%' }}
            >
              <span style={{ fontWeight: 'bold' }}>
                {t("Rent-A-Center")} <span style={{fontStyle: 'italic',fontWeight: 'normal' }}>({validateData(cityName)?cityName:' - '})</span>
              </span>
            </div>
            <div
              style={{ float: 'left', marginRight: '2%', fontSize: '14px',width:'25%'}}
            >
              <span style={{ fontWeight: 'bold' }}>{t('Item #:')}</span>
              <span style={{ fontStyle: 'italic' }}>
                {validateData(headerData)
                  ? validateData(headerData.inventoryNumber)
                    ? headerData.inventoryNumber
                    : '-'
                  : '-'}
              </span>
            </div>
            <div style={{ float: 'left', fontSize: '14px',width:'45%' }}>
              <span style={{ fontWeight: 'bold' }}>{t('Description:')}</span>
              <span style={{ fontStyle: 'italic'}}>
                {validateData(invenData.description)? invenData.description :' - '}
              </span>
            </div>
          </div>

          <div style={{ width: '100%', float: 'left' }}>
            <h4
              style={{
                borderTop: '1px solid black',
                borderBottom: '1px solid black',
              }}
            >
              {t('General Information')}
            </h4>
            <div style={{ width: '49%', float: 'left' }}>
              <div
                style={{ width: '100%', float: 'left', marginBottom: '10px' }}
              >
                <span style={{ width: '50%', float: 'left', fontSize: '13px' }}>
                  {t('Condition')}
                </span>
                <span style={{ width: '50%', float: 'left', fontSize: '13px' }}>
                  {' '}
                  {
                  headerData.conditionDescEn=="Term pushed up/down by Coworker" ? t("Exception") :
                     headerData.conditionDescEn=="Based on DOR-system push" ? t("Auto") : 
                        headerData.conditionDescEn=="New - Full Term"?t("New"):
                        "-"
                  }
                  {/* {validateData(headerData)?validateData(headerData.condition)?headerData.condition:"-":"-"} */}
                </span>
                
              </div>
              <div
                style={{ width: '100%', float: 'left', marginBottom: '10px' }}
              >
                <span style={{ width: '50%', float: 'left', fontSize: '13px' }}>
                  {t('Condition Description')}
                </span>
                <span style={{ width: '50%', float: 'left', fontSize: '13px' }}>
                  { language=='es-MX' || language=='es-US' ? headerData.conditionDescEs : headerData.conditionDescEn }
                </span>
              </div>
              <div
                style={{ width: '100%', float: 'left', marginBottom: '10px' }}
              >
                <span style={{ width: '50%', float: 'left', fontSize: '13px' }}>
                    {t('Term')}
                </span>
                <span style={{ width: '50%', float: 'left', fontSize: '13px' }}>
                {/* <span style={{ width: '25%', float: 'left', fontSize: '13px' }}> */}
                  {validateData(headerData)
                    ? validateData(headerData.maxTerm)
                      ? headerData.maxTerm
                      : '-'
                    : '-'}
                  -
                  {validateData(headerData)
                    ? validateData(headerData.minTerm)
                      ? headerData.minTerm
                      : '-'
                    : '-'}
                  {t('weeks')}
                {/* </span> */}
                </span>
              </div>
              <div
                style={{ width: '100%', float: 'left', marginBottom: '10px' }}
              >
                <span style={{ width: '50%', float: 'left', fontSize: '13px' }}>
                  {t('Condition Edit Reason')}
                </span>
                <span style={{ width: '50%', float: 'left', fontSize: '13px' }}>
                  {headerData.conditionReason}
                </span>
              </div>
            </div>
            <div style={{ width: '50%', float: 'left', marginLeft: '2px' }}>
              <div
                style={{ width: '100%', float: 'left', marginBottom: '10px' }}
              >
                <span style={{ width: '50%', float: 'left', fontSize: '13px' }}>
                  {t('Remaining Value')}
                </span>
                <span style={{ width: '50%', float: 'left', fontSize: '13px' }}>
                  
                  {validateData(headerData)
                    ? validateData(headerData.remainingValue)
                      ? formatter.format(headerData.remainingValue)
                      : '-'
                    : '-'}
                </span>
              </div>
              <div
                style={{ width: '100%', float: 'left', marginBottom: '10px' }}
              >
                <span style={{ width: '50%', float: 'left', fontSize: '13px' }}>
                  {t('Purchase Cost')}
                </span>
                <span style={{ width: '50%', float: 'left', fontSize: '13px' }}>
                  
                  {validateData(headerData)
                    ? validateData(headerData.purchaseCost)
                      ? formatter.format(headerData.purchaseCost)
                      : '-'
                    : '-'}
                </span>
              </div>
              <div
                style={{ width: '100%', float: 'left', marginBottom: '10px' }}
              >
                <span style={{ width: '50%', float: 'left', fontSize: '13px' }}>
                  {t('Price Tag Queued')}
                </span>
                <span style={{ width: '50%', float: 'left', fontSize: '13px' }}>
                  {queued}
                </span>
              </div>
            </div>
          </div>

          <div style={{ width: '100%', float: 'left' }}>
            <h4
              style={{
                borderTop: '1px solid black',
                borderBottom: '1px solid black',
              }}
            >
              {t('Price Tags')}
            </h4>
            <div
              style={{
                width: '49%',
                float: 'left',
                marginRight: '1%',
                marginBottom: '20px',
              }}
            >
              <h5
                style={{
                  padding: '5px',
                  border: '1px solid black',
                  margin: '0px',
                }}
              >
                {t('New Price Tag')}
              </h5>
              <div
                style={{
                  border: '1px solid black',
                  width: '99.7%',
                  float: 'left',
                }}
              >
                <div style={{ width: '96%', float: 'left', margin: '2%' }}>
                  <table style={{ width: '100%' }}>
                    <tbody>
                      <tr>
                        <td style={{ width: '50%' }}>
                          <table style={{ width: '100%', fontSize: '13px' }}>
                            <tbody>
                              <tr>
                                <td style={{ padding: '5px' }}>
                                  {t('Depreciation Percentage')}
                                </td>
                                <td style={{ padding: '5px' }}>
                                  {validateData(priceData.newPriceTag[0]) && validateData(priceData.newPriceTag[0].depreciationPercentage)
                                    ? priceData.newPriceTag[0]
                                        .depreciationPercentage +"%"
                                    : '-'}
                                  
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>
                                  {t('Gross Profit Per Payment')}
                                </td>
                                <td style={{ padding: '5px' }}>
                                  {' '}
                                  {validateData(priceData.newPriceTag[0]) && validateData(priceData.newPriceTag[0].grossProfitPerPayment)
                                    ? formatter.format(priceData.newPriceTag[0]
                                        .grossProfitPerPayment)
                                    : '-'}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Turns')}</td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.newPriceTag[0]) && validateData(priceData.newPriceTag[0].turns)
                                    ? priceData.newPriceTag[0].turns
                                    : '-'}
                                </td>
                              </tr>
                              
                            </tbody>
                          </table>
                        </td>
                        <td style={{ width: '50%' }}>
                          <table style={{ width: '100%', fontSize: '13px' }}>
                            <tbody>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Rate')}</td>
                                <td style={{ padding: '5px' }}>
                                  {/* ${' '} */}
                                  {validateData(priceData.newPriceTag[0]) && validateData(priceData.newPriceTag[0].rate)
                                    ? formatter.format(priceData.newPriceTag[0].rate)
                                    : '-'}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Term')}</td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.newPriceTag[0]) && validateData(priceData.newPriceTag[0].term)
                                    ? priceData.newPriceTag[0].term
                                    : '-'}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Total Cost')}</td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.newPriceTag[0]) && validateData(priceData.newPriceTag[0].totalCost)
                                    ? formatter.format(
                                        priceData.newPriceTag[0].totalCost
                                      )
                                    : '-'}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Cash Price')} </td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.newPriceTag[0]) && validateData(priceData.newPriceTag[0].cashPrice)
                                    ? formatter.format(
                                        priceData.newPriceTag[0].cashPrice
                                      )
                                    : '-'}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div
              style={{
                width: '49% ',
                float: 'left',
                marginLeft: '1%',
                marginBottom: '20px',
              }}
            >
              <h5
                style={{
                  padding: '5px',
                  border: '1px solid black',
                  margin: '0px',
                }}
              >
                {t('Condition Price Tag')}
              </h5>
              <div
                style={{
                  border: '1px solid black',
                  width: '99.7%',
                  float: 'left',
                }}
              >
                <div style={{ width: '96%', float: 'left', margin: '2%' }}>
                  <table style={{ width: '100%' }}>
                    <tbody>
                      <tr>
                        <td style={{ width: '50%' }}>
                          <table style={{ width: '100%', fontSize: '13px' }}>
                            <tbody>
                              <tr>
                                <td style={{ padding: '5px' }}>
                                  {t('Depreciation Percentage')}
                                </td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.autoPriceTag[0]) && validateData(priceData.autoPriceTag[0].depreciationPercentage)
                                    ? priceData.autoPriceTag[0]
                                        .depreciationPercentage+"%"
                                    : '-'}
                                  
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>
                                  {t('Gross Profit Per Payment')}
                                </td>
                                <td style={{ padding: '5px' }}>
                                  {' '}
                                  {validateData(priceData.autoPriceTag[0]) && validateData(priceData.autoPriceTag[0].grossProfitPerPayment)
                                    ? formatter.format(priceData.autoPriceTag[0]
                                        .grossProfitPerPayment)
                                    : '-'}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Turns')}</td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.autoPriceTag[0]) && validateData(priceData.autoPriceTag[0].turns)
                                    ? priceData.autoPriceTag[0].turns
                                    : '-'}
                                </td>
                              </tr>
                              
                            </tbody>
                          </table>
                        </td>
                        <td style={{ width: '50%' }}>
                          <table style={{ width: '100%', fontSize: '13px' }}>
                            <tbody>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Rate')}</td>
                                <td style={{ padding: '5px' }}>
                                  {' '}
                                  {validateData(priceData.autoPriceTag[0]) && validateData(priceData.autoPriceTag[0].rate)
                                    ? formatter.format(priceData.autoPriceTag[0].rate)
                                    : '-'}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Term')}</td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.autoPriceTag[0]) && validateData(priceData.autoPriceTag[0].term)
                                    ? priceData.autoPriceTag[0].term
                                    : '-'}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Total Cost')}</td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.autoPriceTag[0]) && validateData(priceData.autoPriceTag[0].totalCost)
                                    ? formatter.format(
                                        priceData.autoPriceTag[0].totalCost
                                      )
                                    : '-'}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Cash Price')} </td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.autoPriceTag[0]) && validateData(priceData.autoPriceTag[0].cashPrice)
                                    ? formatter.format(
                                        priceData.autoPriceTag[0].cashPrice
                                      )
                                    : '-'}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div
              style={{
                width: '49% ',
                float: 'left',
                marginRight: '1%',
                marginBottom: '10px',
              }}
            >
              <h5
                style={{
                  padding: '5px',
                  border: '1px solid black',
                  margin: '0px',
                }}
              >
                {t('Current Price Tag')}
              </h5>
              <div
                style={{
                  border: '1px solid black',
                  width: '99.7% ',
                  float: 'left',
                }}
              >
                <div style={{ width: '96%', float: 'left', margin: '2%' }}>
                  <table style={{ width: '100%' }}>
                    <tbody>
                      <tr>
                        <td style={{ width: '50%' }}>
                          <table style={{ width: '100%', fontSize: '13px' }}>
                            <tbody>
                              <tr>
                                <td style={{ padding: '5px' }}>
                                  {t('Depreciation Percentage')}
                                </td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.currentPriceTag[0]) && validateData(priceData.currentPriceTag[0].depreciationPercentage)
                                    ? priceData.currentPriceTag[0]
                                        .depreciationPercentage +"%"
                                    : '-'}
                                  
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>
                                  {t('Gross Profit Per Payment')}
                                </td>
                                <td style={{ padding: '5px' }}>
                                  {' '}
                                  {validateData(priceData.currentPriceTag[0]) && validateData(priceData.currentPriceTag[0].grossProfitPerPayment)
                                    ? formatter.format(priceData.currentPriceTag[0]
                                        .grossProfitPerPayment)
                                    : '-'}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>{t("Turns")}</td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.currentPriceTag[0]) && validateData(priceData.currentPriceTag[0].turns)
                                    ? priceData.currentPriceTag[0].turns
                                    : '-'}
                                </td>
                              </tr>
                              
                            </tbody>
                          </table>
                        </td>
                        <td style={{ width: '50%' }}>
                          <table style={{ width: '100%', fontSize: '13px' }}>
                            <tbody>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Rate')}</td>
                                <td style={{ padding: '5px' }}>
                                  {' '}
                                  {validateData(priceData.currentPriceTag[0]) && validateData(priceData.currentPriceTag[0].rate)
                                    ? formatter.format(priceData.currentPriceTag[0].rate)
                                    : '-'}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Term')}</td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.currentPriceTag[0]) && validateData(priceData.currentPriceTag[0].term)
                                    ? priceData.currentPriceTag[0].term
                                    : '-'}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Total Cost')}</td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.currentPriceTag[0]) && validateData(priceData.currentPriceTag[0].totalCost)
                                    ? formatter.format(
                                        priceData.currentPriceTag[0].totalCost
                                      )
                                    : '-'}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Cash Price')} </td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.currentPriceTag[0]) && validateData(priceData.currentPriceTag[0].cashPrice)
                                    ? formatter.format(
                                        priceData.currentPriceTag[0].cashPrice
                                      )
                                    : '-'}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div
              style={{
                width: '49% ',
                float: 'left',
                marginLeft: '1%',
                marginBottom: '10px ',
              }}
            >
              <h5
                style={{
                  padding: '5px',
                  border: '1px solid black',
                  margin: '0px',
                }}
              >
                {t('Edit Price Tag')}
              </h5>
              <div
                style={{
                  border: '1px solid black',
                  width: '99.7%',
                  float: 'left',
                }}
              >
                <div style={{ width: '96%', float: 'left', margin: '2%' }}>
                  <table style={{ width: '100%' }}>
                    <tbody>
                      <tr>
                        <td style={{ width: '50%' }}>
                          <table style={{ width: '100%', fontSize: '13px' }}>
                            <tbody>
                              <tr>
                                <td style={{ padding: '5px' }}>
                                  {t('Depreciation Percentage')}
                                </td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.editPriceTag[0]) && validateData(priceData.editPriceTag[0].depreciationPercentage)
                                    ? priceData.editPriceTag[0]
                                        .depreciationPercentage+"%"
                                    : '-'}
                                  
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>
                                  {t('Gross Profit Per Payment')}
                                </td>
                                <td style={{ padding: '5px' }}>
                                  {' '}
                                  {validateData(priceData.editPriceTag[0]) && validateData(priceData.editPriceTag[0].grossProfitPerPayment)
                                    ? formatter.format(priceData.editPriceTag[0]
                                        .grossProfitPerPayment)
                                    : '-'}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Turns')}</td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.editPriceTag[0]) && validateData(priceData.editPriceTag[0].turns)
                                    ? priceData.editPriceTag[0].turns
                                    : '-'}
                                </td>
                              </tr>
                             
                            </tbody>
                          </table>
                        </td>
                        <td style={{ width: '50%' }}>
                          <table style={{ width: '100%', fontSize: '13px' }}>
                            <tbody>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Rate')}</td>
                                <td style={{ padding: '5px' }}>
                                  {' '}
                                  {validateData(priceData.editPriceTag[0]) && validateData(priceData.editPriceTag[0].rate)
                                    ? formatter.format(priceData.editPriceTag[0].rate)
                                    : '-'}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Term')}</td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.editPriceTag[0]) && validateData(priceData.editPriceTag[0].term)
                                    ? priceData.editPriceTag[0].term
                                    : '-'}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Total Cost')}</td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.editPriceTag[0]) && validateData(priceData.editPriceTag[0].totalCost)
                                    ? formatter.format(
                                        priceData.editPriceTag[0].totalCost
                                      )
                                    : '-'}
                                </td>
                              </tr>
                              <tr>
                                <td style={{ padding: '5px' }}>{t('Cash Price')} </td>
                                <td style={{ padding: '5px' }}>
                                {validateData(priceData.editPriceTag[0]) && validateData(priceData.editPriceTag[0].cashPrice)
                                    ? formatter.format(
                                        priceData.editPriceTag[0].cashPrice
                                      )
                                    : '-'}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </div>
  );
}
